
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const Footer = () => {
  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    // This will eventually connect to a newsletter service
    console.log("Subscribe form submitted");
  };

  return (
    <footer className="bg-white text-gray-800 border-t border-gray-200">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-4">
              <img 
                src="/lovable-uploads/58129023-c293-4dcb-ae66-69419beb90bd.png" 
                alt="Alumni Insights" 
                className="h-10 w-auto"
              />
              <span className="ml-2 font-bold text-gray-800 text-xl">Alumni Insights</span>
            </div>
            <p className="text-gray-600 mb-6">
              Connecting students with alumni from top institutions for personalized guidance.
            </p>
            <div className="space-y-2">
              <div className="flex items-center">
                <Mail size={18} className="text-crimson mr-2" />
                <a href="mailto:contact@alumniinsights.com" className="text-gray-600 hover:text-crimson">contact@alumniinsights.com</a>
              </div>
              <div className="flex items-center">
                <Phone size={18} className="text-crimson mr-2" />
                <a href="tel:+11234567890" className="text-gray-600 hover:text-crimson">(123) 456-7890</a>
              </div>
              <div className="flex items-center">
                <MapPin size={18} className="text-crimson mr-2" />
                <span className="text-gray-600">Boston, MA</span>
              </div>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 border-b border-gray-200 pb-2">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-600 hover:text-crimson hover:underline">Home</Link>
              </li>
              <li>
                <Link to="/browse" className="text-gray-600 hover:text-crimson hover:underline">Browse Alumni</Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-600 hover:text-crimson hover:underline">Services</Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-gray-600 hover:text-crimson hover:underline">How It Works</Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-600 hover:text-crimson hover:underline">Blog</Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-600 hover:text-crimson hover:underline">About Us</Link>
              </li>
            </ul>
          </div>
          
          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4 border-b border-gray-200 pb-2">Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services#qa-sessions" className="text-gray-600 hover:text-crimson hover:underline">Q&A Sessions</Link>
              </li>
              <li>
                <Link to="/services#resume-review" className="text-gray-600 hover:text-crimson hover:underline">Resume Review</Link>
              </li>
              <li>
                <Link to="/services#essay-review" className="text-gray-600 hover:text-crimson hover:underline">Essay Review</Link>
              </li>
              <li>
                <Link to="/services#case-prep" className="text-gray-600 hover:text-crimson hover:underline">Case Preparation</Link>
              </li>
              <li>
                <Link to="/services#test-prep" className="text-gray-600 hover:text-crimson hover:underline">Test Preparation</Link>
              </li>
            </ul>
          </div>
          
          {/* Newsletter */}
          <div>
            <h3 className="text-lg font-semibold mb-4 border-b border-gray-200 pb-2">Stay Updated</h3>
            <p className="text-gray-600 mb-4">
              Subscribe to our newsletter for the latest updates, events, and offers.
            </p>
            <form onSubmit={handleSubscribe}>
              <div className="flex flex-col space-y-2">
                <Input
                  type="email"
                  placeholder="Your email address"
                  className="bg-white border-gray-200 text-gray-800"
                  required
                />
                <Button type="submit" className="w-full bg-crimson hover:bg-crimson-dark">
                  Subscribe
                </Button>
              </div>
            </form>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between">
          <p className="text-gray-600 text-sm">
            &copy; {new Date().getFullYear()} Alumni Insights. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0">
            <ul className="flex space-x-4">
              <li>
                <Link to="/privacy" className="text-gray-600 text-sm hover:text-crimson">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-600 text-sm hover:text-crimson">Terms of Service</Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-600 text-sm hover:text-crimson">FAQ</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
